// TranslateWidget.js
import { useEffect } from "react";
import "./translator.css";

export default function TranslateWidget() {
  useEffect(() => {
    // Check if already added (avoid double injection)
    if (document.getElementById("google-translate-script")) return;

    const script = document.createElement("script");
    script.id = "google-translate-script";
    script.src =
      "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.async = true;

    window.googleTranslateElementInit = () => {
      if (!window.google || !window.google.translate) return;
      new window.google.translate.TranslateElement(
        { pageLanguage: "en" },
        "google_translate_element"
      );
    };

    document.body.appendChild(script);

    return () => {
      // Optional cleanup if unmounted
      const element = document.getElementById("google_translate_element");
      if (element) element.innerHTML = "";
    };
  }, []);

  return <div id="google_translate_element" className="text-right"></div>;
}
